module.exports = __webpack_public_path__ + "img/serrote e tesoura poda e alcool para desisfestação 1.0bff503e.webp";